export enum FlowEnum {
  FUNNEL = 'funnel',
  WEBSHOP = 'webshop',
  AGENT = 'agent'
}